module.exports = __webpack_public_path__ + "img/thex-box.96b492fc.svg";